<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="用户">
                  <!-- <el-input style="width: 180px" v-model="queryForm.userId"></el-input> -->
                  <GridSelectU title="选择用户" style="width: 180px;" labelName="userName" labelValue="id" :value="queryForm.userId" :limit='1'
                    size='small' placeholder='请选择用户' @getValue="getSeachValueUser" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
                  </GridSelectU>
              </el-form-item>
              <el-form-item label="排序类型">
                <el-select
                    class="selectInput"
                    v-model="queryForm.searchType"
                    size="small"
                    placeholder="请选择"
                    clearable
                    style="width: 180px"
                >
                    <el-option v-for="item in checkType" :key="item.key" :label="item.value" :value="item.key"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="人数范围">
                <el-input v-model="queryForm.minValue" size="small" style="width: 180px" placeholder="最小人数范围，不能为0">
                </el-input
                ><br />
                <el-input v-model="queryForm.maxValue" size="small" style="width: 180px" placeholder="最大人数范围，不能为0">
                </el-input>
            </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getMppUserGrowthList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addMppUserGrowth"
        >新建</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editMppUserGrowth(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteMppUserGrowth(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
              :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
        <!-- <span
          title="下载模板"
          class="icon-box"
          @click="importTemplate"
        >
          <Icon color="#606266">
            <ArrowDown />
          </Icon>
        </span>
        <span
          class="icon-box"
          title="导入数据"
          @click="isImport"
        >
          <Icon color="#606266">
            <ArrowExportUp24Regular />
          </Icon>
        </span> -->
        <span
          title="导出数据"
          class="icon-box"
          @click="exportMppUserGrowthList"
        >
          <Icon color="#606266">
            <ArrowDownload24Regular />
          </Icon>
        </span>
        <span
          class="icon-box"
          @click="refreshMppUserGrowthList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="mppUserGrowthList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="userId"
        label="用户"
        width="200"
      > 
          <template slot-scope="scope">
              <div style="text-align: left">账号：{{ scope.row.user?scope.row.user.userName:'--' }}</div>
              <div style="text-align: left">手机：{{ scope.row.user?scope.row.user.userMobile:'--' }}</div>
              <div style="text-align: left">昵称：{{ scope.row.user?scope.row.user.userNickname:'--' }}</div>
              <div style="text-align: left">姓名：{{ scope.row.user?scope.row.user.userRealname:'--' }}</div>
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="directNumber"
        label="直推人数"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="directEffectiveNumber"
        label="有效直推人数"
        width="180"
      > </el-table-column>
<!--      <el-table-column-->
<!--        :show-overflow-tooltip="true"-->
<!--        align="center"-->
<!--        prop="indirectNumber"-->
<!--        label="间推人数"-->
<!--        width="180"-->
<!--      > </el-table-column>-->
<!--      <el-table-column-->
<!--        :show-overflow-tooltip="true"-->
<!--        align="center"-->
<!--        prop="indirectEffectiveNumber"-->
<!--        label="有效间推人数"-->
<!--        width="180"-->
<!--      > </el-table-column>-->
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="teamNumber"
        label="团队人数"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="teamEffectiveNumber"
        label="有效团队人数"
        width="180"
      > </el-table-column>
<!--      <el-table-column-->
<!--        :show-overflow-tooltip="true"-->
<!--        align="center"-->
<!--        prop="growthValue"-->
<!--        label="成长值"-->
<!--        width="180"-->
<!--      > </el-table-column>-->
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="personalPerformance"
        label="个人业绩"
        width="180"
      > </el-table-column>
<!--	  <el-table-column-->
<!--	    :show-overflow-tooltip="true"-->
<!--	    align="center"-->
<!--	    prop="personalPerformanceToday"-->
<!--	    label="今日个人业绩"-->
<!--	    width="180"-->
<!--	  > </el-table-column>-->
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="directPerformance"
        label="直推业绩"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="indirectPerformance"
        label="间推业绩"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="teamPerformance"
        label="团队业绩"
        width="180"
      > </el-table-column>
        <el-table-column
            :show-overflow-tooltip="true"
            align="center"
            prop="personalServiceFee"
            label="个人让利"
            width="180"
        > </el-table-column>
        <el-table-column
            :show-overflow-tooltip="true"
            align="center"
            prop="directServiceFee"
            label="直推让利"
            width="180"
        > </el-table-column>
        <el-table-column
            :show-overflow-tooltip="true"
            align="center"
            prop="teamServiceFee"
            label="团队让利"
            width="180"
        > </el-table-column>
<!--      <el-table-column-->
<!--        :show-overflow-tooltip="true"-->
<!--        align="center"-->
<!--        prop="teamNodePerformance"-->
<!--        label="安置团队业绩"-->
<!--        width="180"-->
<!--      > </el-table-column>-->
<!--	  <el-table-column-->
<!--	    :show-overflow-tooltip="true"-->
<!--	    align="center"-->
<!--	    prop="extendField1"-->
<!--	    label="扩展字段1"-->
<!--	    width="180"-->
<!--	  > </el-table-column>-->
<!--	  <el-table-column-->
<!--	    :show-overflow-tooltip="true"-->
<!--	    align="center"-->
<!--	    prop="extendField2"-->
<!--	    label="扩展字段2"-->
<!--	    width="180"-->
<!--	  > </el-table-column>-->
<!--	  <el-table-column-->
<!--	    :show-overflow-tooltip="true"-->
<!--	    align="center"-->
<!--	    prop="extendField3"-->
<!--	    label="扩展字段3"-->
<!--	    width="180"-->
<!--	  > </el-table-column>-->
      <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="smallPerformance"
          label="小区业绩"
          width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
        width="180"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="200"
      >
        <template slot-scope="scop">
            <div class="operation">
                <div @click="checkNumber(scop.row.id)">
                    <span class="operation-label">校正</span>
                </div>
            </div>
        </template>
        <!-- <template slot-scope="scop">
          <div class="operation"> -->
            
            <!-- <div @click="checkMppUserGrowth(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editMppUserGrowth(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteMppUserGrowth(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div> -->
          <!-- </div>
        </template> -->
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="mppUserGrowthStates[mppUserGrowthState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="mppUserGrowth"
          ref="mppUserGrowthForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="用户"
            prop="userId"
          >
            <el-input
              size="small"
              v-model="mppUserGrowth.userId"
              :disabled="mppUserGrowthState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="直推人数"
            prop="directNumber"
          >
            <el-input
              size="small"
              v-model="mppUserGrowth.directNumber"
              :disabled="mppUserGrowthState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="有效直推人数"
            prop="directEffiectiveNumber"
          >
            <el-input
              size="small"
              v-model="mppUserGrowth.directEffiectiveNumber"
              :disabled="mppUserGrowthState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="间推人数"
            prop="indirectNumber"
          >
            <el-input
              size="small"
              v-model="mppUserGrowth.indirectNumber"
              :disabled="mppUserGrowthState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="有效间推人数"
            prop="indirectEffiectiveNumber"
          >
            <el-input
              size="small"
              v-model="mppUserGrowth.indirectEffiectiveNumber"
              :disabled="mppUserGrowthState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="团队人数"
            prop="teamNumber"
          >
            <el-input
              size="small"
              v-model="mppUserGrowth.teamNumber"
              :disabled="mppUserGrowthState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="有效团队人数"
            prop="teamEffiectiveNumber"
          >
            <el-input
              size="small"
              v-model="mppUserGrowth.teamEffiectiveNumber"
              :disabled="mppUserGrowthState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="成长值"
            prop="growthValue"
          >
            <el-input
              size="small"
              v-model="mppUserGrowth.growthValue"
              :disabled="mppUserGrowthState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="个人业绩"
            prop="personalPerformance"
          >
            <el-input
              size="small"
              v-model="mppUserGrowth.personalPerformance"
              :disabled="mppUserGrowthState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="直推业绩"
            prop="directPerformance"
          >
            <el-input
              size="small"
              v-model="mppUserGrowth.directPerformance"
              :disabled="mppUserGrowthState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="间推业绩"
            prop="indirectPerformance"
          >
            <el-input
              size="small"
              v-model="mppUserGrowth.indirectPerformance"
              :disabled="mppUserGrowthState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="团队业绩"
            prop="teamPerformance"
          >
            <el-input
              size="small"
              v-model="mppUserGrowth.teamPerformance"
              :disabled="mppUserGrowthState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="安置团队业绩"
            prop="teamNodePerformance"
          >
            <el-input
              size="small"
              v-model="mppUserGrowth.teamNodePerformance"
              :disabled="mppUserGrowthState == 'check'"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="mppUserGrowthState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import { UPLOAD_PATH, UPLOAD_API, USER, PRODUCT, PRODUCT_SEARCH, USER_SEARCH } from '@/utils/constant.js';
import GridSelectU from '@/components/gridselect';
export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search,
        GridSelectU
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetMppUserGrowthList();
                    this.getMppUserGrowthList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetMppUserGrowthList();
                    this.getMppUserGrowthList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     userId: '', //用户
                     searchType:'',
                     maxValue:'',
                     minValue:''
                },
                USER_code: USER,
                USER_search: USER_SEARCH,
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                mppUserGrowthState: 'add',
                mppUserGrowthStates: {
                    add: '新建成长考核',
                    check: '查看成长考核',
                    edit: '修改成长考核'
                },
                multipleSelection: [],
                mppUserGrowthList: [],
                mppUserGrowth: {
                    userId: '', //用户
                    directNumber: '', //直推人数
                    directEffiectiveNumber: '', //有效直推人数
                    indirectNumber: '', //间推人数
                    indirectEffiectiveNumber: '', //有效间推人数
                    teamNumber: '', //团队人数
                    teamEffiectiveNumber: '', //有效团队人数
                    growthValue: '', //成长值
                    personalPerformance: '', //个人业绩
                    directPerformance: '', //直推业绩
                    indirectPerformance: '', //间推业绩
                    teamPerformance: '', //团队业绩
                    teamNodePerformance: '', //安置团队业绩
                },
                btnLoading: false,
                rules: {
                    userId: [{ required: true, message: '用户不能为空', trigger: 'blur' }],
                    directNumber: [{ required: true, message: '直推人数不能为空', trigger: 'blur' }],
                    directEffiectiveNumber: [{ required: true, message: '有效直推人数不能为空', trigger: 'blur' }],
                    indirectNumber: [{ required: true, message: '间推人数不能为空', trigger: 'blur' }],
                    indirectEffiectiveNumber: [{ required: true, message: '有效间推人数不能为空', trigger: 'blur' }],
                    teamNumber: [{ required: true, message: '团队人数不能为空', trigger: 'blur' }],
                    teamEffiectiveNumber: [{ required: true, message: '有效团队人数不能为空', trigger: 'blur' }],
                    growthValue: [{ required: true, message: '成长值不能为空', trigger: 'blur' }],
                    personalPerformance: [{ required: true, message: '个人业绩不能为空', trigger: 'blur' }],
                    directPerformance: [{ required: true, message: '直推业绩不能为空', trigger: 'blur' }],
                    indirectPerformance: [{ required: true, message: '间推业绩不能为空', trigger: 'blur' }],
                    teamPerformance: [{ required: true, message: '团队业绩不能为空', trigger: 'blur' }],
                    teamNodePerformance: [{ required: true, message: '安置团队业绩不能为空', trigger: 'blur' }],
                    createTime: [{ required: true, message: '不能为空', trigger: 'blur' }],
                },
                checkType:[],
            };
        },
        created() {
            this.getMppUserGrowthList();
            this.getcheckType()
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            checkNumber(id) {
            get(`/mpp/user/checkUserNumber`, { id: id }).then((res) => {
                if (res.success) {
                    this.$message({
                        message: res.msg,
                        type: 'success',
                        duration: 2000
                    });
                }
            });
            get(`/mpp/usergrowth/findList`, {
                ...this.queryForm,
                pageNum: this.currentPage,
                pageSize: this.pageSize
              }).then((res) => {
                  this.loading = false;
                  if (res.success) {
                      this.userMeansList = res.page.list;
                      this.totalNum = res.page.total;
                  }
              });
          },
            // 获取枚举
            getcheckType(){
                get('/mpp/utils/getEnum?enumType=growth_search_type').then((res) => {
                  if(res.success){
                    this.checkType = res.enumList;
                  }
                });  
            },
            getSeachValueUser(value){
              this.queryForm.userId = value
            },
            resetMppUserGrowthList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.mppUserGrowthList = [];
            },
            resetDialog() {
                this.mppUserGrowthState = 'add';
                this.showDialog = false;
                this.queryForm = {
                  userId: '', //用户
                     searchType:'',
                     maxValue:'',
                     minValue:''
                };
                this.getMppUserGrowthList();
            },
            closeDialog() {
                this.showDialog = false
                this.mppUserGrowth = {
                      id: '', //ID
                      userId: '', //用户
                      directNumber: '', //直推人数
                      directEffiectiveNumber: '', //有效直推人数
                      indirectNumber: '', //间推人数
                      indirectEffiectiveNumber: '', //有效间推人数
                      teamNumber: '', //团队人数
                      teamEffiectiveNumber: '', //有效团队人数
                      growthValue: '', //成长值
                      personalPerformance: '', //个人业绩
                      directPerformance: '', //直推业绩
                      indirectPerformance: '', //间推业绩
                      teamPerformance: '', //团队业绩
                      teamNodePerformance: '', //安置团队业绩
                      createTime: '', //
                };
            },
            submitForm() {
                if (this.mppUserGrowthState == 'add') {
                    this.$refs.mppUserGrowthForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/mpp/usergrowth/add`,{ ...this.mppUserGrowth }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetMppUserGrowthList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.mppUserGrowthState == 'edit') {
                    this.$refs.mppUserGrowthForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/mpp/usergrowth/edit`,{ ...this.mppUserGrowth }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetMppUserGrowthList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addMppUserGrowth() {
                this.showDialog = true;
                this.mppUserGrowthState = 'add';
            },
            checkMppUserGrowth(mppUserGrowthId) {
                console.log(mppUserGrowthId);
                this.currentMppUserGrowthId = mppUserGrowthId;

                this.getMppUserGrowthById();
                this.showDialog = true;
                this.mppUserGrowthState = 'check';
            },
            editMppUserGrowth(mppUserGrowthId) {
                console.log('mppUserGrowth', mppUserGrowthId);
                if (mppUserGrowthId) {
                    this.currentMppUserGrowthId = mppUserGrowthId;
                    this.getMppUserGrowthById();
                } else {
                    this.mppUserGrowth = { ...this.mppUserGrowth, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.mppUserGrowthState = 'edit';
            },
            deleteMppUserGrowth(mppUserGrowthId) {
                let ids = '';
                if (mppUserGrowthId) {
                    ids = mppUserGrowthId;
                } else {
                    ids = this.multipleSelection.map((mppUserGrowth) => mppUserGrowth.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/mpp/usergrowth/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetMppUserGrowthList();
                                this.getMppUserGrowthList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshMppUserGrowthList() {
                this.resetMppUserGrowthList();
                this.getMppUserGrowthList();
            },
            getMppUserGrowthList(query = {}) {
                this.loading = true;
                get(`/mpp/usergrowth/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.mppUserGrowthList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getMppUserGrowthById() {
                get(`/mpp/usergrowth/get`,{ id: this.currentMppUserGrowthId }).then((res) =>{
                    if(res.success){
                      this.mppUserGrowth = { ...this.mppUserGrowth, ...res.mppUserGrowth };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportMppUserGrowthList() {
                //this.btnLoading = true;
                exprotExcel(`/mpp/usergrowth/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/mpp/usergrowth/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/mpp/usergrowth/importData`,formData);
              this.refreshMppUserGrowthList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getMppUserGrowthList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getMppUserGrowthList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>